import React from 'react';
import { generateFullName } from 'utils/generateFullNameUtils';

const UploadedByTemplate = ({ rowData }) => {
  const userDetails = rowData?.created_by_details;
  const isClient = userDetails?.access_level?.toLowerCase() === 'client';
  const isGroup = Boolean(userDetails?.group_id);
  const userName = generateFullName(userDetails);
  if (!userDetails) {
    return <span className="text-muted">-</span>;
  }

  return (
    <>
      <span className="p-column-title text-break">Uploaded By</span>
      <div>
        {/* Access Level Icon */}
        <i className={isClient ? 'fas fa-user ps-2' : 'fas fa-user-tie'} style={{ fontSize: '14px', marginRight: '4px' }} />
        &nbsp;
        <span className="text-gray-500 font-size-12 text-capitalize text-nowrap">
          {isGroup ? 'Group' : userDetails?.access_level?.replace(/-/g, ' ') || 'Client'}
        </span>
        <span className="text-gray-500 font-size-12">:</span>
        <br />
        {/* User Name */}
        <span className={`${!isClient ? 'ms-2' : ''} font-weight-bold text-sm font-size-12`}>{userName || 'Unknown User'}</span>
      </div>
    </>
  );
};

export default UploadedByTemplate;
